import classNames from 'classnames';
import { getFiGrowthBook } from '../../lib/growthbook';
import styles from './StepProgress.module.scss';

interface StepProgressProps {
  /** 1-indexed position of the current step */
  step: number;
}

/**
 * The four form steps each rendered their own copy of this markup, with the step count and the
 * filled/unfilled colours hardcoded per file. One component instead, so the count can follow the
 * flow rather than being restated four times.
 *
 * The total is flag-aware: the merged success screen folds the upgrade step into the
 * confirmation, so the flow is four steps with it on and five with it off. Reading the flag
 * before GrowthBook loads resolves false, which matches the control path.
 */
export default function StepProgress({ step }: StepProgressProps) {
  const mergedSuccessEnabled = getFiGrowthBook().getFeatureValue('nano-merged-success-screen', false);
  const total = mergedSuccessEnabled ? 4 : 5;

  return (
    <div className={styles.progress}>
      <div className={styles.label}>
        Step {step} of {total}
      </div>
      <div className={styles.segments}>
        {Array.from({ length: total }, (_, index) => (
          <div key={index} className={classNames(styles.segment, { [styles.filled]: index < step })} />
        ))}
      </div>
    </div>
  );
}
